<template>
	<div :class="classNames">
		<div :class="classNames+ '_search'">
			<el-row>
				<el-col :span="5">
					<el-button type="primary" @click="createClass">新建课程</el-button>
					<a style="color:#1989fa;margin-left: 6px;cursor:pointer;font-size:12px;text-decoration: none;white-sapce: nowrap" href="https://doutuimao.feishu.cn/docs/doccnoVIzpjIr8vE90BWERUvSXb" target="_blank">课程上传教程></a>
				</el-col>
				<el-col :span="7">
					<div :class="classNames+ '_search_con_item'" v-if="staticPath === '/'">
						<span :class="classNames+ '_search_con_item_title'">抖音可售卖</span>
						<el-select v-model="searchObj.is_dy_sale" placeholder="请选择" @change="changeStatus">
							<el-option key="" label="全部" value=""/>
							<el-option :key="1" label="是" :value="1"/>
							<el-option :key="2" label="否" :value="2"/>
						</el-select>
					</div>
					<div :class="classNames+ '_search_con_item'" v-else-if="staticPath === '/ks/'">
						<span :class="classNames+ '_search_con_item_title'">课程库状态</span>
						<el-select v-model="searchObj.ks_product_status" placeholder="请选择" @change="changeStatus">
							<el-option v-for="item in commonMixin_ksClassKuStatusList" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>
					<div style="visibility:hidden" v-else>&npsp;</div>
				</el-col>
				<el-col :span="6">
					<div :class="classNames+ '_search_con_item'">
						<span :class="classNames+ '_search_con_item_title'">状态</span>
						<el-select v-model="searchObj.status" placeholder="请选择" @change="changeStatus">
							<el-option v-for="item in selectList" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>
				</el-col>
				<el-col :span="6">
					<div :class="classNames+ '_search_con_item'">
						<el-input placeholder="请输入内容" v-model="searchObj.title" class="input-with-select">
							<el-button slot="append" type="primary"  @click="search">查询</el-button>
						</el-input>
					</div>
				</el-col>
			</el-row>
		</div>
		<div :class="classNames+ '_search'">
			<el-row>
				<el-col :span="6">
					 <!-- zzxtj--进度条 -->
					<div>
						<span :class="classNames + '_search_con_item_title'">
							<span>已使用：{{ConsumeInfo.use}}GB/{{ConsumeInfo.total}}GB
								<span>
									<el-popover placement="bottom" width="400" trigger="hover">
										<el-table :data="gridData">
											<el-table-column width="150" property="capacity"
												label="容量（GB）"></el-table-column>
											<el-table-column property="endTime" label="过期时间"></el-table-column>
										</el-table>
										<i class="el-icon-info" slot="reference"></i>
									</el-popover>
								</span>
							</span>
							
							<span :class="classNames + '_search_con_item_handleRed'" @click="handleRed">扩容</span>
						</span>
					</div>
					<div>
						<el-progress :percentage="percentage" :color="percentage<100 ? '' : 'red'"></el-progress>
					</div>
				</el-col>
			</el-row>
		</div>
		<div :class="classNames+'_con'">
			<div :class="classNames+'_con_table'">
				<el-table v-if="moveKey" id="group_id" :data="classList.list"
					:header-cell-style="{background: '#F5F7FA',color:'#454D53'}" :cell-class-name="cellClassName">
				<!-- 	<el-table-column type="index" label="排序">
					</el-table-column> -->
					<div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
					</div>
					<!-- 拖拽句柄 -->
					<el-table-column width="55">
						<template slot="header">
						</template>
						<template slot-scope="scope">
							<div class="drag-handles-chapter1 move">
								<p v-if="scope">拖 <br>
									动<br>
									此<br>
									处<br>
									排<br>
									序<br>
									</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="排序" width="90">
						<template slot="header">
								<span  style="margin-left:10px;">排序</span>
						</template>
						<template slot-scope="scope">
							<div  @click="clickSort(scope.row,sortIndex(scope.row.id))" style="margin-left:10px;width:20px;white-space: nowrap;">{{sortIndex(scope.row.id)}}</div>
							<!-- <div>
								<template v-if="scope.row.sortFlag" >
									<el-input placeholder="" v-model="scope.row.sort" maxlength="3" @blur="editSortSave(scope.row, 'getClassLists')" @input="() => changeSort(scope.row)" :ref="'inp'+ scope.row.id" :validate-event="true" :class="{'inp_error': !scope.row.sort}"/>
									<span v-if="!scope.row.sort" style="color: #f56c6c;font-size: 12px;line-height:14px;display:inline-block">排序不能为空</span>
								</template>
								<p v-else @click="editSort(scope.row)" style="cursor:pointer">{{scope.row.sort}}</p>
							</div> -->
						</template>
					</el-table-column>
					<el-table-column :label="item.label" :prop="item.prop" v-for="(item, index) in headerList"
						:type="item.prop" :key="index" :width="item.width">
						<template slot-scope="scope">
							<div v-if="item.prop === 'columnObj'" :class="classNames+ '_table_imgtitle'">
								<div :class="classNames+ '_table_imgtitle_left'">
									<img :src="scope.row.list_width_img"/>
									<tagsList :data="scope.row.come_from"></tagsList>
									<div v-if="staticPath === '/wx/'" class="lable">
										{{scope.row.wx_mini==1?"豆包知道":"豆包甄选"}}
									</div>
									<!-- <span>{{scope.row.duration}}</span> -->
								</div>
								<div :class="classNames+ '_table_imgtitle_right'">
									<div :class="classNames+ '_table_right_top'">
										<p @click="copyUrl2(scope.row.title)" :class="classNames+ '_table_right_title'">
											{{scope.row.title}}
										</p>
										<p :class="classNames+ '_table_right_price'">￥{{scope.row.price}} <span class="audit-price" v-if="scope.row.audit_price > 0">({{scope.row.audit_price}}  待审核)</span></p>
										<p style="font-size: 12px;line-height:14px;margin-top:4px" v-if="staticPath === '/'">抖音可售卖：{{scope.row.is_dy_sale == 1? '是': '否'}}</p>
									</div>
									<div :class="classNames+ '_table_right_bot_status'" v-if="scope.row.dy_audit_data || scope.row.dy_product_status_desc">
										<span :class="classNames+ '_table_bot_status_tit1'" >[ {{scope.row.dy_audit_data || scope.row.dy_product_status_desc}} ]</span>
									</div>
									<!-- <div :class="classNames+ '_table_right_bot_status'" v-if="scope.row.dy_product_status_desc">
										<span :class="classNames+ '_table_bot_status_tit1'" >[ {{scope.row.dy_product_status_desc}} ]</span>
									</div> -->
									<div :class="classNames+ '_table_right_bot'">
										<div :class="classNames+ '_table_bot_status'">
											<span :class="classNames+ '_table_bot_status_tit'" v-statusColor="{status: scope.row.status, list: selectList}">{{scope.row.status | handleStatus}}</span>
											<!-- <el-tooltip :content="scope.row.reason" placement="top" v-if="scope.row.reason">
												<span :class="classNames+ '_table_bot_reason'">下架/驳回原因</span>
											</el-tooltip> -->
											 <el-popover
												placement="top"
												title="下架/驳回原因"
												width="700"
												trigger="hover"
												popper-class="reject-reason-wrap"
												>
												<div style="max-height: 600px;display:flex;flex-direction:column">
													<div v-html="scope.row.reason" class="reject-reason">
													</div>
												</div>
												<span :class="classNames+ '_table_bot_reason'"  v-if="scope.row.reason" slot="reference">下架/驳回原因</span>
											</el-popover>
											<el-tooltip :content="scope.row.reject" placement="top" v-if="scope.row.reject">
												<span :class="classNames+ '_table_bot_reason'">更新驳回原因</span>
											</el-tooltip>
											<span :class="classNames+ '_table_bot_reason'" v-if="scope.row.update_status">{{scope.row.update_status}}</span>
										</div>
										<div :class="classNames+ '_table_bot_time'">
											{{scope.row.created_time}}
										</div>
									</div>
								</div>
							</div>
							<div v-else-if="item.prop === 'verify_counts'">
								<span>{{ scope.row.lesson_counts }}/</span>
								<span>{{ scope.row.lesson_up_counts }}/</span>
								<span>{{ scope.row.lesson_draft_counts }}</span>
							</div>
							<div v-else-if="item.prop === 'buy'" class="view_buy_comm">
								<div class="buy-item"><i class="iconfont">&#xe604;</i>{{scope.row.view_counts}}</div>
								<div class="buy-item"><i class="iconfont">&#xe603;</i>{{scope.row.buy_counts}}</div>
								<div class="buy-item"><i class="iconfont">&#xe605;</i>{{scope.row.comm_counts}}</div>
							</div>
							<div v-else-if="item.prop === 'ksClasskuStatus'" class="ks-classku-status-box">
								<div>{{ getKsStatusStr(scope.row.ks_product_status) }}</div>
								<el-tooltip
                                    v-if="scope.row.ks_product_status==3" 
                                    class="item" 
                                    effect="dark" 
                                    :content="`驳回原因：${scope.row.ks_product_reject}`" 
                                    placement="top-start">
                                    <div class="rejection-box">
                                        驳回原因：{{ scope.row.ks_product_reject }}
                                    </div>
                                </el-tooltip>
							</div>
							<div v-else-if="item.prop === 'my_h5BuyLink'">
								<div @click="copyH5link(scope.row)" class="h5link-copy-btn" v-if="showH5BuyLink(scope.row)">
									复制
								</div>
							</div>
							<div v-else>{{scope.row[item.prop]}}</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="right" width="100" fixed="right">
						<template slot-scope="scope">
							<span @click="editStatus(scope.row)"
								:class="classNames+'_operation_title'" v-if="handleShow(scope.row.status, 1)">下架</span>
								<span @click="editStatus(scope.row)"
									:class="classNames+'_operation_title'" v-if="handleShow(scope.row.status, 2)">上架</span>
									<!-- <span @click="editCaoGaoStatus(scope.row)"
									:class="classNames+'_operation_title'" v-if="scope.row.status == 4">上架</span> -->
							<span @click="edit(scope.row)" :class="classNames+'_operation_title'" v-if="handleShow(scope.row.status, 3)">编辑</span>
							<span @click="preivew(scope.row)" :class="classNames+'_operation_title'" v-if="handleShow(scope.row.status, 4)">查看</span>
							<!-- <el-popover placement="top-start" width="200" trigger="hover" v-if="handleShow(scope.row.status, 5) && staticPath === '/'" popper-class="share_popper" v-model="scope.row.shareVisible" @show="popoverShow(scope.row)">
								<template>
									<div class="share_img" :id="scope.row.id" v-loading="scope.row.loading">
										<img :src="scope.row.codeUrl"/>
									</div>
									<p class="share_title">请打开抖音扫二维码</p>
									<p class="share_info" @click="downLoad(scope.row)" v-if="!scope.row.loading">点击下载</p>
									</template>
								<span slot="reference"
									:class="classNames+'_operation_title'">分享</span>
							</el-popover> -->
							<span @click="deltes(scope.row)" :class="classNames+'_operation_title'" v-if="handleShow(scope.row.status, -1)">删除</span>
							<span @click="syncWx(scope.row)"
								:class="classNames+'_operation_title'" v-if="handleShow(scope.row.is_sync_wx, 'wx') && staticPath !=='/wx/'">同步微信</span>
							<span @click="recall(scope.row)"
								:class="classNames+'_operation_title'" v-if="handleShow(scope.row.status, 7)">撤回</span>
							<span @click="goChapter(scope.row)" :class="classNames+'_operation_title'" v-if="(scope.row.status && scope.row.status!== 4) || scope.row.lesson_counts">课程目录</span>
							<span :class="classNames+'_operation_title'" @click="opeartion(scope.row)">设置</span>
							<!-- <span :class="classNames+'_operation_title'" @click="uploads(scope.row)" :style="{'color': scope.row.rights_img ? '': 'red'}">上传版权</span> -->
						</template>
					</el-table-column>
				</el-table>
			</div>
			<Pagination  layout="sizes, prev, pager, next, jumper , total"  :pageSize="searchObj.page_size" :pageSizes='[10,20,50]'  @sizeChange="sizeChange" @change="changeSize" :total="classList.total" ref="pagination" v-model="searchObj.page" v-if="classList.total > 10"></Pagination>
			<submit-dialog :editParams="editParams" v-model="dialogVisible" @sure="sureClick"></submit-dialog>
			<!-- 设置排序 -->
			<el-dialog :visible.sync="isSortMask" top="400px" title="课程排序" width="400px" :close-on-click-modal="false" :close-on-press-escape="false" :modal='false'  @mousedown.native.stop="" @mouseup.native.stop="">
				<div style="position:fixed;background: rgba(0,0,0,.5);top: 0;left: 0;right: 0;bottom: 0;z-index: -1;" @click.prevent.stop="() => {}"></div>
				<el-input type="number" placeholder="请输入排序值" :min="1" v-model="orderValue"/>
				<div style="margin-top:20px;color:red;">请输入排序值，数字越小越靠前</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click.prevent.stop="isSortMask = false">取 消</el-button>
					<el-button type="primary" @click.prevent.stop="theInputValueSorting()" :disabled="!orderValue">确 定</el-button>
				</span>
			</el-dialog>
			<el-dialog
				title="上传版权"
				:visible.sync="uploadVisible"
				width="40%"
				custom-class="uploadCopyright"
				>
					<div slot="title" style="display:flex;align-items:center">
						<h5>上传版权</h5>
						<span style="margin-left:12px;font-size: 12px;color:#1989fa;cursor:pointer" @click="downLoadTemplate">下载模板</span>
					</div>
					<div class="uploadCopyright_con">
						<multipleUploadImg v-if="uploadVisible" v-model="submitParams.url"></multipleUploadImg>
						<p>(下载后打印纸质签字并拍照上传)</p>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="uploadVisible = false">取 消</el-button>
						<el-button type="primary" :disabled="!submitParams.url" @click="submitImg">提交</el-button>
					</span>
			</el-dialog>
		</div>
		<opearteDialog v-model="opeartionFlag" :id="row.id" :itemobj="row"/>
	</div>
</template>

<script>
	import {
		data
	} from './data.js'
	import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	import Pagination from '@/components/pagination/pagination.vue'
	import { common } from '../../mixin/common.js'
	import { uploadCopyRight } from '../../mixin/uploadCopyRight.js'
	import multipleUploadImg from '@/components/upload/multiple_upload_img.vue'
	import qualificationIsAdd from '@/components/mixin/qualificationIsAdd.js'
	import Sortable from 'sortablejs'
	import opearteDialog from './opearteDialog.vue'
	import { sendPost } from '@/api/http.js'
	export default {
		name: 'SpecialColumn',
		mixins: [data, common,uploadCopyRight, qualificationIsAdd],
		data() {
			return {
				classNames: 'specialColumn',
				value: '',
				input3: '',
				searchObj: {
					single: -1,
					status: '',
					title: '',
					page: 1,
					page_size: 10,
					is_dy_sale: '',
					ks_product_status: '' // 快手课程库状态
				},
				gridData: [{//进度条旁icon数据
					//容量
					capacity: '',
					endTime: '',
				}],
				moveKey:true,//
				copy_sort:'',//克隆数据

				// selectList: [{
				// 		label: '全部',
				// 		value: ''
				// 	},
				// 	{	label: '已上架',
				// 		value: 1
				// 	},
				// 	{
				// 		label: '已下架',
				// 		value: -2
				// 	},
				// 	{
				// 		label: '已驳回',
				// 		value: 2
				// 	},
				// 	{
				// 		label: '待审核',
				// 		value: 3
				// 	},
				// 	{
				// 		label: '草稿',
				// 		value: 4
				// 	}
				// ]
				isSortMask:false,//排序弹窗
				orderValue:'',//输入的排序值
				sortRow:'',//正在排序的row
				pageScroll:'',//
				opeartionFlag: false,
				row: {},
				ConsumeInfo:{},//余量管理
			}
		},
		created() {
			this.initData()
			this.getClassLists()
			this.getConsumeInfo()
			this.getUserInfo()
		},
		components: {
			Pagination,
			multipleUploadImg,
			opearteDialog
		},
		computed: {
			...mapState(['breadCrumbList']),
			...mapState('createClass',['classList']),
			sortIndex(){
				return (id) => {
					let index=this.copy_sort && this.copy_sort.findIndex(item=>item.id==id)
					return this.searchObj.page_size*(this.searchObj.page-1)+index+1 
				}
			},
			percentage(){
            let num = (this.ConsumeInfo.use / (this.ConsumeInfo.total / 100)).toFixed(2);
            if(num == 'NaN'){
                return 0;
            }
            return Number(num);
        }
			
		},
		filters: {
			// handleStatus(value) {
			// 	switch(value) { 
			// 		case -2:
			// 			return '下架'
			// 		case -1:
			// 			return ''
			// 		case 1:
			// 			return '上架'
			// 		case 2:
			// 			return '驳回'
			// 		case 3:
			// 			return '待审核'
			// 		case 4:
			// 			return '草稿'
			// 		default:
			// 			return ''
			// 	}
			// }
		},
		methods: {
			...mapActions('class', ['recallAudit', 'courseLib', 'productsynwx']),
			...mapActions('createClass', ['getClassList']),
			...mapActions('column', ['createdspecial','movespecial', 'upstatus', 'createH5linkAPI']),
		// 	handleShow(value, type) {
		// 		let obj = {
		// 			1:[1],
		// 			2:[-2, 2,4],
		// 			3:[-2, 1,2,4],
		// 			4: [3],
		// 			5:[1, -2]
		// 		}
		// 		if(obj[type].includes(value)) {
		// 			return true
		// 		} 
		
		// 	},
		  // 获取数据列表
		getConsumeInfo() {//获取余量管理
			sendPost('/exchange/plan/use/info').then(res => {
				this.ConsumeInfo = res;
				this.gridData[0].capacity = this.ConsumeInfo.total+'GB'
			})
        },
			  // 获取数据列表
		getUserInfo() {//获取余量管理
			sendPost('/user/user/info').then(res => {
				console.log('UserInfo', res)
				this.gridData[0].endTime = res.expire_time;
			})
        },

		clickSort(row,orderValue){
				this.isSortMask=true
				this.sortRow=row
				this.orderValue=orderValue
			},
			initData(){
				if(this.staticPath=='/'){
					let my_h5BuyLinkIndex = this.headerList.findIndex(item => item.prop == 'my_h5BuyLink')
					this.headerList.splice(my_h5BuyLinkIndex,1)
				}
				if(this.staticPath=='/ks/'){
					let ksClassKuStatusObj = {
						prop: 'ksClasskuStatus',
						label: '快手课程库状态',
						width: 140
					}
					let buyIndex = this.headerList.findIndex(item => item.prop == 'buy')
					this.headerList.splice(buyIndex+1, 0, ksClassKuStatusObj)
				}
			},
			// 获取快手课程库状态文字
			getKsStatusStr(statusId){
				return this.commonMixin_ksClassKuStatusList.find(item => item.value==statusId).label || '未知状态'
			},
			// 展示h5支付链接
			showH5BuyLink(item){
				if(this.staticPath=='/wx/' && item.wx_mini!=1){ // 微信甄选
					return false
				}else if(item.status==4){ // 状态：草稿
					return false
				}else{
					return true
				}
			},
			handleRed(){
				console.log('handleRed---跳转',this.staticPath + "storCenter")
				this.$router.push(this.staticPath + "storCenter");
			},
			// 点击复制-h5购课链接
			async copyH5link(item){
				// console.log('item:',item)
				let { id, title } = item
				let res = await this.createH5linkAPI({product_id: id})
				// console.log('copyH5link-res:',res)
				let copyText = `购买【${title}】点击 ${res.url}`
				this.$copyText(copyText).then(
					e=>{
						// console.log('复制成功：', e);
						this.$message({
							message: '复制成功',
							type: 'success'
						})
					},
					e=>{
						console.log('复制失败：', e);
						this.$message.error('复制失败')
					}
				)
			},
			//输入值排序
			async theInputValueSorting() {//参数 up_id:手上拖着的id   down_id:拖到谁上面或下面
				try{
					this.pageScroll=this.getPageScrollY()
					console.log(9998,this.pageScroll);

					let obj={
							id:this.sortRow.id,
							new_sort:this.orderValue,
						}
					await this.movespecial(obj)
					await this.getClassLists()
					this.isSortMask=false
					this.orderValue=''
					setTimeout(() => {
						this.getPageScrollY(this.pageScroll)
					}, 500);
					
					

					}catch(err){
					this.getClassLists()
					this.isSortMask=false
					this.orderValue=''

					}

			},
			getPageScrollY(top) {
			if (top || Number(top) == 0) { //设置垂直滚动值
				document.querySelector(".content_right_con_scrollbar .el-scrollbar__wrap").scrollTop=top
			} else { //获取垂直滚动值
				return document.querySelector(".content_right_con_scrollbar .el-scrollbar__wrap").scrollTop
			}
		},
		copyUrl2(row){
			this.copyToClipboard(row); 
			this.$message({
					message: '复制成功',
					type: 'success',
					duration: 3000
				})
			},
			copyToClipboard(content){
				//window.clipboardData的作用是在页面上将需要的东西复制到剪贴板上，
				//提供了对于预定义的剪贴板格式的访问，以便在编辑操作中使用。
			if (window.clipboardData) {
				/*
				window.clipboardData有三个方法:
				（1）clearData(sDataFormat) 删除剪贴板中指定格式的数据。sDataFormat:"text","url"
				（2）getData(sDataFormat) 从剪贴板获取指定格式的数据。 sDataFormat:"text","url"
				（3）setData(sDataFormat, sData) 给剪贴板赋予指定格式的数据。返回 true 表示操作成功。
				*/
				window.clipboardData.setData('text', content);
			} else {
				(function (content) {
				//oncopy 事件在用户拷贝元素上的内容时触发。
				document.oncopy = function (e) {
					e.clipboardData.setData('text', content);
					e.preventDefault(); //取消事件的默认动作
					document.oncopy = null;
				}
				})(content);
				//execCommand方法是执行一个对当前文档/当前选择/给出范围的命令。
				//'Copy':将当前选中区复制到剪贴板。 
				document.execCommand('Copy');
			}
			},
		 //行拖拽
			rowDropOne() {
				const table = document.querySelector('#group_id tbody')
				const _this = this
				Sortable.create(table, { //记得引入sortable
				forceFallback: true, // ignore the HTML5 DnD behaviour and force the fallback to kick in
				handle:".move",
				onEnd({ newIndex, oldIndex }) {//后端替换失败记住请求接口刷新数据   本地数据不需要换
					if(newIndex!= oldIndex){
						let up=oldIndex
						let down=newIndex
						let obj={
							up_id:_this.copy_sort[up].id,
							down_id:_this.copy_sort[down].id
						}
						_this.movespecial(obj).catch(err=>{
							_this.getClassLists()

						})

						let item=_this.copy_sort.splice(up,1)
						_this.copy_sort.splice(down,0,item[0])
				
					}
				}
				})
		
			},
			changeStatus() {
				// this.searchObj.page = 1
				// this.$refs.pagination.firstPage()
				// this.getClassLists(this.searchObj)
				// this.$refs.pagination.firstPage()
				this.noDataName = 'noData'
				this.getClassLists(true)
			},
			changeSize(page) {
				this.searchObj.page = page
				this.getClassLists()
			},
			sizeChange(size){//每页多少条
				this.searchObj.page_size = size
				this.getClassLists()
			},
			getClassLists(flag) {
				if(flag) {
					this.searchObj.page = 1
				}
				this.getClassList(this.searchObj)
			},
			async sureClick() {
				let res = await this.createdspecial({ status: this.editParams.status, id: this.row.id, edit_type: 'status'})
				this.dialogVisible = false
					this.getClassLists()

				if(res === 'success') {
					// this.editParams.status == 1 ? this.$confirm('课程提交成功,是否上传课程章节内容？<p style="color:red">（没有章节审核员不给与审核哦）</p>', '提示',{
					// 	distinguishCancelAndClose: false,
					// 	dangerouslyUseHTMLString: true,
					// 	confirmButtonText: '是',
					// 	cancelButtonText: '否',
					// 	center: true
					// })
					// .then(() => {
					// 	this.handleBreadCrumb('/chapter', '课程目录',this.row.id)
					// }) : ''
					// this.$refs.pagination.firstPage()
				}
			},
			async editStatus(row) {
				await this.interceptFun(row)
				let content = ''
				let title = ''
				let sureBtn = ''
				let cancelBtn = ''
				let putList = [-2,4, 2]
				let status = ''
				if(putList.includes(row.status * 1)) {
					content='上架课程需要进行审核，审核将自动上架，是否提交审核？'
					title='信息'
					sureBtn='是'
					cancelBtn = '否',
					status = 1
				} else {
					content='确定要下架该课程吗？'
					title='温馨提示'
					sureBtn='确认'
					cancelBtn = '取消'
					status = -2
					await this.testCourseLib(row.id)
				}
				this.editParams = {
					content,
					title,
					sureBtn,
					cancelBtn,
					status
				}
				this.row = row
				this.dialogVisible = true
				// this.$confirm(content, title, {
				// 	distinguishCancelAndClose: false,
				// 	confirmButtonText: sureBtn,
				// 	cancelButtonText: cancelBtn,
				// 	customClass: this.classNames + '_common_dialog',
				// 	center: true
				// })
				// .then(async () => {
				// 	let res = await this.createdspecial({ status: status, id: row.id })
				// 	if(res === 'success') {
				// 		this.$refs.pagination.firstPage()
				// 	}
				// })
			},
			async edit(row) {
				// if(row.status == 1) {
				// 	return this.upEdit('课程')
				// }
				// if(row.dy_product_status === 2) {
				// 	this.$message({
				// 		message: '抖音课程库审核中，暂不支持编辑',
				// 		type: 'warning',
				// 		duration: 3000
				// 	})
				// 	return
				// }
				if(row.status == 4) {
					let name = row.lesson_counts ? 'editColumnOther' : 'createColumn' 
					this.handleBreadCrumb(this.staticPath + name, '编辑课程', row.id)
				} else {
					await this.interceptFun(row)
					if(row.status === 1 && this.staticPath === '/') {
						await this.testCourseLib(row.id)
					}
					this.handleBreadCrumb(this.staticPath + 'editColumn', '编辑课程', row.id)
				}
				
				console.log(row.status, 'row.statusrow.statusrow.statusrow.status')
				// this.handleBreadCrumb('/editColumn', '编辑课程', row.id)
			},
			handleBreadCrumb(path, name, id, index = 2) {
				let breadCrumbList = this.breadCrumbList.slice(0,index)
				breadCrumbList[index] = {
					title: name,
					path: id ? path + '/' + id : path
				}
				localStorage.setItem('breadCrumbList', JSON.stringify(breadCrumbList))
				this.$router.push({
					path: id ? path + '/' + id : path,
					// query: {
					// 	// breadCrumbList: JSON.stringify(breadCrumbList),
					// 	id
					// }
				})
				breadCrumbList[index] = {
					title: name,
					path: this.$route.fullPath
				}
			},
			downLoad(row) {
				this.domToImage(row)
				// let a = document.createElement('a')
			},
			async createClass() {
				let flag = await this.testIsAddProduct()
				if(!flag) {
					return
				}
				this.handleBreadCrumb(this.staticPath + 'createColumn', '新建课程')
			},
			// goCourseGuide() {
			// 	this.handleBreadCrumb(this.staticPath + 'courseGuide', '课程上传教程>')
			// },
			search() {
				// this.searchObj.page = 1
				// this.$refs.pagination.firstPage()
				// this.getClassLists(this.searchObj)
				// this.$refs.pagination.firstPage()
				this.noDataName = 'noData'
				this.getClassLists(true)
			},
			test(params) {
				console.log(params, '[[[]]]')
			},
			preivew(row) {
				this.handleBreadCrumb(this.staticPath + 'preivewColumn', '查看课程', row.id)
			},
			async goChapter(row) {
				await this.interceptFun(row)
				this.handleBreadCrumb(this.staticPath +  'chapter', '课程目录', row.id)
			},
			recall(row) {
				this.$confirm('确定要撤回吗？', '信息', {
					distinguishCancelAndClose: false,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: this.classNames + '_common_dialog',
					center: true
				})
				.then(async() => {
					await this.recallAudit({ product_id: row.id })
					this.getClassLists()
				})
			},
			deltes(row) {
				this.$confirm('确定要删除吗？', '信息', {
					distinguishCancelAndClose: false,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: this.classNames + '_common_dialog',
					center: true
				})
				.then(async() => {
					let res =  await this.createdspecial({ status: -1, id: row.id, edit_type: 'status'})
					this.$message(
							{
								type: 'success',
								message: '删除成功',
								duration: 3000
							}
						)
						this.getClassLists()
				})
			},
			async editCaoGaoStatus(row) {
				// this.editParams = {
				// 	content:'上架课程需要进行审核，审核将自动上架，是否提交审核？',
				// 	title: '信息',
				// 	sureBtn: '是' ,
				// 	cancelBtn:'否',
				// 	status: 1
				// }
				// this.row = row
				// this.dialogVisible = true
				let res = await this.upstatus({id: row.id})
				if(res.status == 2) {
					this.$confirm('您有必填项信息未填写，请先去填写信息', '提示', {
						distinguishCancelAndClose: false,
						confirmButtonText: '去填写',
						cancelButtonText: '取消',
						customClass: this.classNames + '_common_dialog',
						center: true
					})
					.then(async() => {
						if(row.status == 1) {
							this.handleBreadCrumb(this.staticPath +  'editColumn', '编辑课程', row.id)
						} else {
							this.handleBreadCrumb(this.staticPath + 'createColumn', '编辑课程', row.id)
						}
						// this.handleBreadCrumb(this.staticPath + 'editColumn', '编辑课程', row.id)
					})
				} else {
					this.editParams = {
						content:'上架课程需要进行审核，审核将自动上架，是否提交审核？',
						title: '信息',
						sureBtn: '是' ,
						cancelBtn:'否',
						status: 1
					}
					this.row = row
					this.dialogVisible = true
				}
			},
			testCourseLib(id) {
				return new Promise(async (resolve) => {
					let res = await this.courseLib({ id })
					if(res.is_enter === 1) {
						this.$confirm('该课程已入抖音课程库编辑/下架后需要重新推到抖音课程库审核，请谨慎操作', '信息', {
							distinguishCancelAndClose: false,
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							customClass: this.classNames + '_common_dialog',
							center: true
						})
						.then(async() => {
							resolve()
						})
					} else {
						resolve()
					}
				})
			},
			async syncWx(row) {
				await this.interceptFun(row)
				this.$confirm('注意：每个课程只可同步微信1次，请确认是否需要同步微信，当点击同步微信之后，同步按钮将消失（若同步微信的课程在微信端被删除了，不可恢复以及再次同步，请谨慎操作）', '信息', {
					title: '温馨提示',
					distinguishCancelAndClose: false,
					confirmButtonText: '立即同步',
					cancelButtonText: '暂不同步',
					customClass: this.classNames + '_common_dialog common_dialog_tips',
					center: true
				})
				.then(async() => {
					await this.productsynwx({ product_id: row.id })
					this.$set(row, 'is_sync_wx', 1)
					this.$message(
						{
							type: 'success',
							message: '同步微信成功',
							duration: 3000
						}
					)
				})
			},
			async opeartion(row) {
				await this.interceptFun(row)
				this.row = row
				this.opeartionFlag = true
			},
			interceptFun(row) {
				const obj = {
					'更新审核中': [row.update_status],
					'信息待抖音课程库审核中': [row.dy_audit_data, row.dy_product_status_desc]
				}
				let flag = false
				for (const key in obj) {
					if(obj[key].includes(key)) {
						flag = true
						break;
					}
				}
				return new Promise((resolve) => {
					if(!flag) {
						return resolve()
					}
					this.$confirm('该课程正在更新审核中是否确认操作？', '信息', {
						title: '温馨提示',
						distinguishCancelAndClose: false,
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						customClass: this.classNames + '_common_dialog',
						center: true
					})
					.then(async() => {
						resolve()
					})
				})
			}
		},
		watch: {
			searchObj: {
				deep: true,
				handler(news) {
					// this.getClassLists(news)
				}
			},
			classList:{
				handler(news) {
					this.moveKey=false
					setTimeout(() => {
					this.moveKey=true
						this.$nextTick(()=>{
							this.rowDropOne()
						})
					}, 100);
					this.copy_sort=JSON.parse(JSON.stringify(this.classList.list))
				}
			},
			isCheckboxArr:{
				deep: true,
				handler(news) {
					if(this.isCheckboxArr.length==this.chapterList.list.length&&chapterList.list.length>0){
					this.checkAll=true
				}else{
					this.checkAll=false

				}
				}
			}
		}
	}
</script>
<style lang="less">
.el-table__row{
		&:hover{
			.drag-handles-chapter1{
				opacity: 1!important;
			}
		}
	}

	.drag-handles-chapter1{
		width: 60px;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		box-sizing: border-box;
		white-space: nowrap;
	
		padding: 0px 8px;
		font-size: 12px;

		color: #FFFFFF;
		background: rgba(0, 0, 0, 0.6);
		opacity: 0;
	}
	@classNames: specialColumn;
	.@{classNames} {
		.el-table::before {
			background-color: transparent;
		}
		.@{classNames}_search_btn {
			width: 70px;
			height: 40px;
			background: #1989FA;
			border-radius: 0px 2px 2px 0px;
			color: #FFFFFF;
			font-size: 14px;
		}
		.@{classNames}_operation_title {
			color: #1989FA;
			font-size: 14px;
			cursor: pointer;
			// &:not(:last-child) {
			// 	margin-right: 12px;
			// }

		}
		.@{classNames}_table_imgtitle {
			display: flex;
			height: 123px;
			.@{classNames}_table_imgtitle_left {
				position: relative;
				margin-right: 10px;
				width: 163px;
				height: 123px;
				flex-shrink: 0;
				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
				span {
					position: absolute;
					bottom: 0;
					left: 0;
					width: 100%;
					height: 26px;
					background: #000000;
					opacity: 0.5;
					text-align: center;
					line-height:26px;
					font-size: 14px;
					font-weight: 400;
					color: #FFFFFF;
				}
				.lable{
					width: 70px;
					height: 27px;
					background: rgba(0, 0, 0, 0.6);
					border-radius: 10px;
					text-align: center;
					line-height:27px;
					font-size: 10px;
					font-weight: 400;
					color: #FFFFFF;
					position: absolute;
					bottom: 8px;
					left: 8px;
				}
			}
			.@{classNames}_table_imgtitle_right {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				.@{classNames}_table_right_top {
					.@{classNames}_table_right_title {
						width: 155px;
						font-size: 14px;
						color: #606266;
						line-height: 14px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
					}
					.@{classNames}_table_right_price {
						margin-top: 5px;
						font-size: 16px;
						font-weight: 500;
						color: #EC4561;
						line-height: 16px;
						span.audit-price{
							color: #666;
							font-size: 12px;
							font-weight: normal
						}
					}
				}
				.@{classNames}_table_right_bot_status {
					.@{classNames}_table_bot_status_tit1 {
							font-size: 12px;
							height: 18px;
							border-radius: 12px;
							margin-right: 10px;
							text-align: center;
							line-height: 18px;
    						color: rgb(90, 221, 179);
						}
				}
				.@{classNames}_table_right_bot {
					.@{classNames}_table_bot_status {
						display: flex;
						align-items: center;
						.@{classNames}_table_bot_status_tit {
							width: 66px;
							height: 24px;
							border-radius: 12px;
							margin-right: 10px;
							text-align: center;
							line-height: 24px;
						}
						
						.@{classNames}_table_bot_reason {
							font-size: 14px;
							color: #65B2FF;
							line-height: 20px;
						}
					}
					.@{classNames}_table_bot_time {
						font-size: 14px;
						color: #606266;
						line-height: 14px;
						margin-top: 4px;
					}
				}
			}
		}
		.@{classNames}_search_con_item {
			.el-input-group__append {
				background: #1989FA;
				color: #fff;
			}
		}
		.el-table__header {
			width: 100%!important;
		}
		.el-table__body {
			width: 100%!important;
		}
	}
	.@{classNames}_common_dialog {
		padding: 30px;
		width: 360px;
		box-sizing: border-box;
		.el-message-box__header {
			padding: 0;
		}
		.el-message-box__headerbtn {
			top: 0;
			right: 0;
		}
		.el-message-box__content {
			padding: 0;
			.el-message-box__message {
				padding-top: 12px;
				padding-bottom: 16px;
			}
		}
		.el-message-box__btns {
			.el-button {
				width: 77px;
				height: 28px;
				padding: 0;
				text-align: center;
				line-height: 28px;
			}
		}
	}
	.common_dialog_tips{
		width: 460px;
		.el-message-box__btns {
			display: flex;
			justify-content: center;
			.el-button:first-child{
				margin-right: 50px;
			}
			
		}
	}
	.view_buy_comm {
		.buy-item{
			margin-bottom: 6px;
			.iconfont {
				margin-right: 6px;
			}
		}
	}
</style>
<style lang='less' scoped>
	@classNames: specialColumn;

	.@{classNames} {
		display: flex;
		flex-direction: column;
		height: 100%;
		.@{classNames}_search_con_item_title {
			white-space: nowrap;
			font-size: 14px;
			color: #606266;
			margin-right: 12px;
		}
		.@{classNames}_search_con_item_handleRed{
			margin-left: 25px;
			color: blue;
			cursor: pointer;
		}
		.@{classNames}_search {
			margin-bottom: 40px;
			// .@{classNames}_search_con {
			// 	display: flex;

				.@{classNames}_search_con_item {
					display: flex;
					align-items: center;
					margin-right: 16px;
				}
			// }
		}

		.@{classNames}_con {
			flex: 1;
			display: flex;
			flex-direction: column;
			/*.@{classNames}_con_table {
				flex: 1;
				height: 0;
			}*/
		}
		.ks-classku-status-box{
			.rejection-box{
				width: 100%;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				cursor: pointer;
			}
		}
		.h5link-copy-btn{
			color: #1989FA;
			font-size: 14px;
			cursor: pointer;
			text-align: center;
		}
	}
</style>
